import { Datepicker } from "flowbite";
import { apiService } from "../apiService";
import { chartHelper } from "./chartHelper";

// expose to globalThis Scope

globalThis.statsHelper = {
  datepickerFromPositions: null,
  datepickerToPositions: null,
  lineChartClicks: null,
  lineChartViews: null,
  dateFrom: null,
  dateTo: null,
  contentId: null,
  config: {
    elementDatePickerFrom: "oneDateFieldPositions",
    elementDatePickerTo: "twoDateFieldPositions",
    elementLineChartViews: "linechartViews",
    elementLineChartClicks: "linechartClicks",
    elementFormPositions: "formPositions",
    elementCurrentPositionId: "currentPositionId",
    elementNamePositions:"positionId",
    datePickerFormat: "dd.mm.yyyy",
    interval: "month",
    views: {
      tickColor: "#6371f1",
      dataColor: "#9495b8",
      legendColor: "rgb(148, 149, 184)",
      gridColor: "#eaeaf5"
    },
    clicks: {
      tickColor: "#0694a2",
      dataColor: "#0694a2",
      legendColor: "rgb(148, 149, 184)",
      gridColor: "#eaeaf5"
    }
  },


  init: function(config = {})
  {

    for (const [key, value] of Object.entries(config))
    {
      this.config[key] = value;
    }
    config = this.config;

    this.initLineCharts(config.elementLineChartViews, config.elementLineChartClicks);
    this.initDatePickersPositions(config.elementDatePickerFrom, config.elementDatePickerTo, config.elementFormPositions);
    this.initPositionsTable();
  },
  initLineCharts: function(elementIdViews, elementIdClicks)
  {
    this.initLineChartViews(elementIdViews);
    this.initLineChartClicks(elementIdClicks);
  },
  initLineChartViews: function(elementId)
  {
    if (this.lineChartViews)
    {
      return this.lineChartViews;
    }
    this.lineChartViews = chartHelper.getChart(elementId, this.config.views.gridColor, this.config.views.tickColor, this.config.views.dataColor, this.config.views.legendColor);
    return this.lineChartViews;
  },
  initLineChartClicks: function(elementId)
  {
    if (this.lineChartClicks)
    {
      return this.lineChartClicks;
    }
    this.lineChartClicks = chartHelper.getChart(elementId, this.config.clicks.gridColor, this.config.clicks.tickColor, this.config.clicks.dataColor, this.config.clicks.legendColor);
    return this.lineChartClicks;
  },

  updateLineChartsPositions: async function()
  {
    if (this.lineChartViews === null || this.lineChartClicks === null)
    {
      throw new Error("Position LineCharts not initialized");
    }

    let response = await apiService.getPositionData(this.contentId, this.dateFrom, this.dateTo, this.config.interval);
    let data = response.data;
    let lineChartViews = this.lineChartViews;
    lineChartViews.data.labels = data.map(row => row.date);
    lineChartViews.data.datasets.forEach((dataset) =>
    {
      dataset.data = data.map(row => row.adviews);
    });
    lineChartViews.update();
    let lineChartClicks = this.lineChartClicks;
    lineChartClicks.data.labels = data.map(row => row.date);
    lineChartClicks.data.datasets.forEach((dataset) =>
    {
      dataset.data = data.map(row => row.pageviews);
    });
    lineChartClicks.update();
  },


  initDatePickersPositions: function(elementFrom, elementTo, formId)
  {

    const datepickerFromPositionsElement = document.getElementById(elementFrom);
    const datepickerToPositionsElement = document.getElementById(elementTo);

    let options = { format: this.config.datePickerFormat };


    this.datepickerFromPositions = new Datepicker(datepickerFromPositionsElement, options, {
      id: elementFrom,
      override: true
    });

    this.datepickerToPositions = new Datepicker(datepickerToPositionsElement, options, {
      id: elementTo,
      override: true
    });

    const form = document.getElementById(formId);

    const that = this;
    form.addEventListener("submit", async function(event)
    {
      event.preventDefault();
      that.contentId = document.getElementById(that.config.elementCurrentPositionId).textContent;
      that.dateFrom = String(Math.round(that.datepickerFromPositions.getDate().getTime() / 1000));
      that.dateTo = String(Math.round(that.datepickerToPositions.getDate().getTime() / 1000));
      await that.updateLineChartsPositions();
    });
  },
  updatePositionDatePickers: function updatePositionDatePickers(dateFrom, dateTo)
  {

    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.datepickerToPositions.setDate(dateTo);
    this.datepickerFromPositions.setDate(dateFrom);


  },

  initPositionsTable: function()
  {
    let that = this;
    let positionButtons = document.getElementsByName(this.config.elementNamePositions);
    for (i = 0; i < positionButtons.length; i++)
    {
      positionButtons[i].addEventListener("click", async function(e)
      {
        let contentId = this.value;
        document.getElementById(that.config.elementCurrentPositionId).textContent = contentId;
        let dateFrom = document.getElementById("dateFrom" + contentId).value;
        let dateTo = document.getElementById("dateTo" + contentId).value;
        that.contentId = contentId;
        that.updatePositionDatePickers(dateFrom, dateTo);
        await that.updateLineChartsPositions();
      });
    }
  }
};